import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitUserCreatePage } from './housing-unit-user-create';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HousingUnitUserCreatePage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitUserCreatePage),
	],
})
export class HousingUnitUserCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-user-create/housing-unit-user-create.module.ts